import styled from "@emotion/styled";
import type { NFTCollateralPosition } from "@stepfinance/lending";
import { imageFromPlatformName, StepTable } from "@stepfinance/react";
import { Col, Collapse, Row } from "antd";
import type { FC } from "react";

import { useCalculatePriceForDisplayCurrency } from "../../../hooks";
import type { ReformattedCollateralizedPosition, ReformattedYieldPosition } from "../../../types/lending";
import { useLocalStorageState } from "../../../utils/utils";
import { genBalance, genHeader } from "../../Collapse";
import { getExpandIcon } from "../ChevronCollapse/ChevronCollapse";

const { Panel } = Collapse;

interface LendingPanelProps {
  platform: string;
  title?: string;
  totalValue: number | null;
  columns: any;
  localStorageKey: string;
  dataSource: ReformattedCollateralizedPosition[] | ReformattedYieldPosition[] | NFTCollateralPosition[];
}

export const LendingPanel: FC<LendingPanelProps> = ({
  platform,
  title,
  totalValue,
  columns,
  dataSource,
  localStorageKey,
}) => {
  const calculatePriceForDisplayCurrency = useCalculatePriceForDisplayCurrency();
  const [panelActiveKey, setPanelActiveKey] = useLocalStorageState(localStorageKey, "1");

  return (
    <LendingRow>
      <Col span={24}>
        <Collapse
          ghost
          defaultActiveKey={panelActiveKey}
          expandIconPosition="end"
          expandIcon={getExpandIcon}
          onChange={(activeKey) => {
            setPanelActiveKey(activeKey);
          }}
        >
          <StyledInnerPanel
            key="1"
            header={genHeader(imageFromPlatformName(platform) ?? "", platform + (title ? ` - ${title}` : ""))}
            extra={genBalance(calculatePriceForDisplayCurrency(totalValue))}
          >
            <StepTable<ReformattedCollateralizedPosition | ReformattedYieldPosition | NFTCollateralPosition>
              columns={columns}
              dataSource={dataSource}
              pagination={false}
            />
          </StyledInnerPanel>
        </Collapse>
      </Col>
    </LendingRow>
  );
};

const LendingRow = styled(Row)`
  padding-top: 30px !important;
  width: 100%;
`;

const StyledInnerPanel = styled(Panel)`
  > .ant-collapse-header {
    padding-right: 12px !important;

    h2 {
      font-size: 14px;
    }

    .ant-collapse-arrow {
      top: 11px !important;
    }

    .ant-collapse-extra {
      margin-right: 14px !important;
    }
  }

  > .ant-collapse-content {
    overflow: hidden;
  }
`;
